import type {
  ComponentMode,
  Purchase,
  PurchaseProduct,
  PurchaseStatus,
} from 'types';

interface State extends StrictOmit<Purchase, 'purchaseProducts'> {
  mode: ComponentMode;
  step: 1 | 2;
  canSubmit: boolean;
  defaultStatus: PurchaseStatus;
  purchaseProducts: Array<
    Prettify<
      PurchaseProduct & Record<'amount' | 'maxAmount' | 'updatedPrice', number>
    >
  >;
}
const initialState: Partial<State> = {};

type Action =
  | {
      type: 'UPDATE_PURCHASE_PRODUCTS';
      payload: Pick<typeof initialState, 'purchaseProducts'>;
    }
  | {
      type: 'UPDATE_PURCHASE_CAN_SUBMIT';
      payload: Pick<typeof initialState, 'canSubmit'>;
    }
  | {
      type: 'UPDATE_PURCHASE_STEP';
      payload: Pick<typeof initialState, 'step'>;
    }
  | undefined;
const initialAction: Action = undefined;

export { initialAction, initialState };
